import { lazy } from "react";
import MinimalLayout from "./../layout/MinimalLayout/index";
import Loadable from "../components/Loadable";
import { FrontLayout } from "../../front/FrontLayout";
const Login = Loadable(lazy(() => import("../../front/auth/Login")));

const LoginForm = Loadable(
  lazy(() =>
    import("../../front/auth/Login").then((module) => ({
      default: module.LoginForm,
    })),
  ),
);

const SignupForm = Loadable(
  lazy(() =>
    import("../../front/auth/Login").then((module) => ({
      default: module.SignupForm,
    })),
  ),
);

const ForgotPasswordForm = Loadable(
  lazy(() =>
    import("../../front/auth/Login").then((module) => ({
      default: module.ForgotPasswordForm,
    })),
  ),
);

const ResetPasswordForm = Loadable(
  lazy(() =>
    import("../../front/auth/Login").then((module) => ({
      default: module.ResetPasswordForm,
    })),
  ),
);

const OtpVerificationForm = Loadable(
  lazy(() =>
    import("../../front/auth/Login").then((module) => ({
      default: module.OtpVerificationForm,
    })),
  ),
);
//import StripeElements from "../../components/StripeElements";

const StripeElements = Loadable(lazy(() => import("../../components/StripeElements")));
const Home = Loadable(lazy(() => import("./../../front/pages/Home")));
const ContactUs = Loadable(lazy(() => import("../../front/pages/ContactUs")));
const StaticPage = Loadable(lazy(() => import("../../front/pages/StaticPage")));
const StartInterviewSession = Loadable(lazy(() => import("../../front/pages/StartInterviewSession")));
const CreateJob = Loadable(lazy(() => import("../../front/pages/CreateJob")));
const Dashboard = Loadable(lazy(() => import("../../front/pages/dashboard/Dashboard")));
const Profile = Loadable(lazy(() => import("../../front/pages/Profile")));
const JobDetails = Loadable(lazy(() => import("../../front/pages/JobDetails")));
const Payment = Loadable(lazy(() => import("../../front/pages/Payment")));
const Interview = Loadable(lazy(() => import("../../components/AIInterview/Interview")));
const Success = Loadable(lazy(() => import("../../front/pages/Success")));
const Notifications = Loadable(lazy(() => import("../pages/common/Notifications")));
const DocuSignSuccess = Loadable(lazy(() => import("../../components/Docusignsuccess")));
const AgreementDetails = Loadable(lazy(() => import("../../front/pages/AgreementDetails")));
const AboutUs = Loadable(lazy(() => import("../../front/pages/AboutUs")));
const PaymentMethods = Loadable(lazy(() => import("../pages/common/PaymentMethods")));
const Subscriptions = Loadable(lazy(() => import("../pages/common/subscription/Subscriptions")));
const CurrentPlan = Loadable(lazy(() => import("../pages/common/subscription/Currentplans.jsx")));
const PaymentSuccess = Loadable(lazy(() => import("../../components/PaymentSuccess")));
const TransactionHistory = Loadable(lazy(() => import("../pages/common/Transactions.jsx")));
const Career = Loadable(lazy(() => import("../../front/pages/Career.jsx")));
const ReferredEmployers = Loadable(lazy(() => import("../../front/pages/affiliate/ReferredEmployers.jsx")));
const ReferredCommissions = Loadable(lazy(() => import("../../front/pages/affiliate/ReferredCommissions.jsx")));
const Payout = Loadable(lazy(() => import("../../front/pages/affiliate/Payout.jsx")));
const RecruiterForm = Loadable(lazy(() => import("../../front/pages/agency/RecruiterForm.jsx")));
const RecruiterList = Loadable(lazy(() => import("../../front/pages/agency/RecruiterList.jsx")));
const ReferredEmployees = Loadable(lazy(() => import("../../front/pages/affiliate/ReferredEmployees.jsx")));
const BlogListing = Loadable(lazy(() => import("../../front/pages/BlogListing.jsx")));
const BlogDetail = Loadable(lazy(() => import("../../front/pages/BlogDetail.jsx")));

const PaymentWithStripe = () => (
  <StripeElements>
    <Payment />
  </StripeElements>
);

const PaymentMethodsWithStripe = () => (
  <StripeElements>
    <PaymentMethods />
  </StripeElements>
);

const SubscriptionsWithStripe = () => (
  <StripeElements>
    <Subscriptions />
  </StripeElements>
);

const FrontRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/",
      element: (
        <FrontLayout
          cmp={Home}
          isHeader={true}
          isFooter={true}
          mainFooter={true}
        />
      ),
    },
    {
      path: "/start-interview-session",
      element: (
        <FrontLayout
          cmp={StartInterviewSession}
          isHeader={false}
          isFooter={false}
          isProtected={true}
        />
      ),
    },
    {
      path: "/create-job",
      element: (
        <FrontLayout
          cmp={CreateJob}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/blogs",
      element: (
        <FrontLayout
          cmp={BlogListing}
          isHeader={true}
          isFooter={true}
          isProtected={false}
        />
      ),
    },
    {
      path: "/blogs/:id",
      element: (
        <FrontLayout
          cmp={BlogDetail}
          isHeader={true}
          isFooter={true}
          isProtected={false}
        />
      ),
    },
    {
      path: "/agreement-details",
      element: (
        <FrontLayout
          cmp={AgreementDetails}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/create-job/:jobId",
      element: (
        <FrontLayout
          cmp={CreateJob}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/payment-methods",
      element: (
        <FrontLayout
          cmp={PaymentMethodsWithStripe}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/subscription-plan",
      element: (
        <FrontLayout
          cmp={SubscriptionsWithStripe}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/current-plan",
      element: (
        <FrontLayout
          cmp={CurrentPlan}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/transactions",
      element: (
        <FrontLayout
          cmp={TransactionHistory}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/job-details/:jobId",
      element: (
        <FrontLayout
          cmp={JobDetails}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/payment",
      element: (
        <FrontLayout
          cmp={PaymentWithStripe}
          isHeader={false}
          isFooter={false}
          isProtected={true}
        />
      ),
    },
    {
      path: "/success",
      element: (
        <FrontLayout
          cmp={Success}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/payment-success",
      element: (
        <FrontLayout
          cmp={PaymentSuccess}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/dashboard",
      element: (
        <FrontLayout
          cmp={Dashboard}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/profile",
      element: (
        <FrontLayout
          cmp={Profile}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/notifications",
      element: (
        <FrontLayout
          cmp={Notifications}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },
    {
      path: "/login",
      element: (
        <Login>
          <LoginForm />
        </Login>
      ),
    },
    {
      path: "/signup",
      element: (
        <Login>
          <SignupForm />
        </Login>
      ),
    },
    {
      path: "/forgot",
      element: (
        <Login>
          <ForgotPasswordForm />
        </Login>
      ),
    },
    {
      path: "/otp-verification",
      element: (
        <Login>
          <OtpVerificationForm />
        </Login>
      ),
    },
    {
      path: "/ai-interview",
      element: (
        <FrontLayout
          cmp={Interview}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },

    {
      path: "/contract/success",
      element: (
        <FrontLayout
          cmp={DocuSignSuccess}
          isHeader={true}
          isFooter={true}
          isProtected={true}
        />
      ),
    },

    {
      path: "/reset-password",
      element: (
        <Login>
          <ResetPasswordForm />
        </Login>
      ),
    },
    {
      path: "/privacy-policy",
      element: <StaticPage />,
    },
    {
      path: "/contact-us",
      element: <ContactUs />,
    },
    {
      path: "/terms-and-conditions",
      element: <StaticPage />,
    },
    {
      path: "/about-us",
      element: <AboutUs />,
    },
    {
      path: "/career",
      element: <Career />,
    },
    {
      path: "/referred-employers",
      element: <ReferredEmployers />,
    },
    {
      path: "/referred-employees",
      element: <ReferredEmployees />,
    },
    {
      path: "/referred-commissions",
      element: <ReferredCommissions />,
    },
    {
      path: "/affiliate/payout",
      element: <Payout />,
    },
    {
      path: "/recruiters",
      element: <RecruiterList />,
    },
    {
      path: "/recruiter-form",
      element: <RecruiterForm />,
    },
  ],
};

export default FrontRoutes;
